import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { TypographyProps } from '@mui/material/Typography';

type Props = {
  id: string;
  title: string;
  color?: TypographyProps['color'];
};

const IdTitle: FC<Props> = ({ id, title, color = 'grey.600' }) => {
  return (
    <>
      <Typography variant="body1" color="white">
        {id}:
      </Typography>

      <Typography variant="body1" color={color}>
        {title}
      </Typography>
    </>
  );
};

export default IdTitle;
